import { coreOrganizationsUnlinkPostAsyncSlice } from './post';

export const {
	requestPostCoreOrganizationsUnlink,
	resetPostCoreOrganizationsUnlink
} = coreOrganizationsUnlinkPostAsyncSlice.asyncActionCreators;
